import type * as Sentry from '@sentry/browser';

import { ERROR_IGNORE_LIST } from './const';

const escapeRegExp = (value: string): string => {
    // eslint-disable-next-line unicorn/prefer-string-replace-all -- replaceAll is unavailable in some browsers
    return value.replace(/[$()*+.?[\\\]^{|}]/gu, '\\$&');
};

export const canIgnoreEventFromErrorsList = (event: Sentry.Event): boolean => {
    const exceptionValue = event.exception?.values?.[0]?.value;

    if (!exceptionValue) {
        return false;
    }

    return ERROR_IGNORE_LIST.some((filterItem: string | RegExp) => {
        if (filterItem instanceof RegExp) {
            return filterItem.test(exceptionValue);
        }

        if (typeof filterItem !== 'string') {
            return false;
        }

        return new RegExp(escapeRegExp(filterItem)).test(exceptionValue);
    });
};
